<template>
    <div class="no-ons-campaign" :class="{ 'third-panel': !user.$$chatId }" v-if="user.profile.no_ons_campaign === 1">
        <span>#Goodbye_To_ONS 캠페인 참여 중</span>
        <div class="circle m-l-5">
            <i @click="banCampaign" class="material-icons">close</i>
        </div>
    </div>
</template>

<script>
import userService from '@/services/user'

export default {
    name: 'NoOnsCampaignBadge',
    props: {
        user: Object,
    },
    methods: {
        async banCampaign() {
            try {
                const idx = await this.$modal.basic({
                    body: '캠페인 자격을 박탈하시겠습니까?',
                    buttons: [
                        {
                            label: 'CANCEL',
                            class: 'btn-normal',
                        },
                        {
                            label: 'CONFIRM',
                            class: 'btn-primary',
                        },
                    ],
                })
                if (idx === 1) {
                    const { msg } = await userService.banNoOnsCampaign(this.user.id)
                    this.$toast.success(msg)
                    const userLists = this.$store.getters.userLists
                    const restUserLists = userLists.filter(u => u.id !== this.user.id)
                    this.$set(this.user.profile, 'no_ons_campaign', -1)
                    this.$store.commit('setUserLists', [this.user, ...restUserLists])
                }
            } catch (e) {
                if (e.data.key === 'unavailable_friend') {
                    this.$toast.error(e.data.msg)
                }
            }
        },
    },
}
</script>

<style scoped lang="scss">
.no-ons-campaign {
    display: flex;
    padding: 4px 16px;
    margin-top: 11px;
    color: white;
    font-size: 10px;
    display: flex;
    align-items: center;
    width: fit-content;
    height: 18px;
    border-radius: 6px;
    background-image: linear-gradient(276deg, #0064fb, #419aff);
    @include f-medium;

    .circle {
        background: white;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 12px;
        height: 12px;
    }

    i {
        color: $blue-facebook;
        font-size: 12px;
    }
}
</style>
